<template>
  <proActivityLogSetup
    v-model:dialog="dialog"
    :data="data"
    @update:dialog="dialog = $event"
  />
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="px-2 pt-4 pb-0">
                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="To Date"
                        density="compact"
                        single-line
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="6">
                      <v-btn class="bg-brand" type="submit" ref="searchButton"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
   
    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Proposal Record</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    <div class="text-right pr-2">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="goTo('/sales/add-crm-proposal')"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                      >
                        Add Proposal
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="getSchema"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  
                  <template v-slot:item.proposal_status="{ item }">
                    <v-chip
                      v-if="item.proposal_status_id == 1"
                      color="grey-darken-1"
                      size="small"
                      class="text-capitalize"
                      >{{ item.proposal_status.name }}</v-chip
                    >
                    <v-chip
                      v-else-if="item.proposal_status_id == 2"
                      color="warning"
                      size="small"
                      class="text-capitalize"
                      >{{ item.proposal_status.name }}</v-chip
                    >
                    <v-chip
                      v-else-if="item.proposal_status_id == 3"
                      color="indigo"
                      size="small"
                      class="text-capitalize"
                      >{{ item.proposal_status.name }}</v-chip
                    >
                    <v-chip
                      v-else-if="item.proposal_status_id == 4"
                      color="info"
                      size="small"
                      class="text-capitalize"
                      >{{ item.proposal_status.name }}</v-chip
                    >
                    <v-chip
                      v-else-if="item.proposal_status_id == 5"
                      color="purple"
                      size="small"
                      class="text-capitalize"
                      >{{ item.proposal_status.name }}</v-chip
                    >
                    <v-chip
                      v-else-if="item.proposal_status_id == 6"
                      color="success"
                      size="small"
                      class="text-capitalize"
                      >{{ item.proposal_status.name }}</v-chip
                    >
                    <v-chip
                      v-else-if="item.proposal_status_id == 7"
                      color="error"
                      size="small"
                      class="text-capitalize"
                      >{{ item.proposal_status.name }}</v-chip
                    >
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      v-if="item.status == 1"
                      color="success"
                      size="small"
                      class="text-capitalize"
                      >Active</v-chip
                    >
                    <v-chip
                      v-else
                      color="red"
                      size="small"
                      class="text-capitalize"
                      >Inactive</v-chip
                    >
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      small
                      @click="viewInvoice(item)"
                      v-if="
                        $updateAccess($route.fullPath) && item.status == '1'
                      "
                      title="View Invoice"
                      color="blue"
                    >
                      mdi-file-document-outline
                    </v-icon>

                    <v-icon
                      class="ml-2 edit-button"
                      color="primary"
                      @click="viewLead(item)"
                    >
                      mdi mdi-eye
                    </v-icon>

                    <v-icon
                      class="ml-2 edit-button"
                      color="primary"
                      @click="editItem(item)"
                      v-if="$updateAccess($route.fullPath) && (item.proposal_status_id == 1 || item.proposal_status_id == 2)"
                    >
                      mdi mdi-pencil-outline
                    </v-icon>

                    <v-tooltip text="Daily Update" location="top">
                      <template #activator="{ props }">
                        <v-icon
                          v-bind="props"
                          class="ml-2 edit-button"
                          color="primary"
                          @click="dailyUpdate(item)"
                          v-if="$updateAccess($route.fullPath)"
                          style="cursor: pointer"
                        >
                          mdi mdi-update
                        </v-icon>
                      </template>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import proActivityLogSetup from "@/components/module/sales/proposal/proActivityLogSetup.vue";
import formattedDate from "@/plugins/dateFormatter";
import { useField, useForm } from "vee-validate";
import { ref } from "vue";
import { useStore } from "vuex";
import * as yup from "yup";

export default {
  components: {
    proActivityLogSetup,
  },
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    dialog: false,
    data: {},
    headers: [
      { title: "#SL", align: "center", key: "index", width: "7%", sortable: false, },
      { title: "Code", key: "code", align: "left", sortable: false },
      { title: "Company Name", key: "company_name", align: "left", sortable: false, },
      { title: "Company Email", key: "company_email", align: "left", sortable: false, },
      { title: "Company Phone", key: "company_phone", align: "left", sortable: false, },
      { title: "Proposal Status", key: "proposal_status", align: "left", sortable: false, },
      { title: "Total", key: "total", align: "left", sortable: false },
      { title: "Status", align: "center", key: "status", sortable: true },
      { title: "Actions", align: "center", key: "actions", sortable: false },
    ],
  }),
  watch: {},
  created() {},
  computed: {
    getSchema() {
      return this.$store.getters.getSalesProposalsList;
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        // from_date: yup.date().required().label("From Date"),
        // to_date: yup.date().required().label("To Date"),
      }),
    });

    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();
    const submit = handleSubmit((values) => {
      loading.value = true;
      values.from_date = formattedDate(from_date.value.value);
      values.to_date = formattedDate(to_date.value.value);
      store
        .dispatch("getSalesProposalsList", values)
        .then((response) => {
          loading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });
    return {
      submit,
      from_date,
      to_date,
      errorMessages,
      loading,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    editItem(item) {
      this.$router.push({
        name: "add-crm-proposal",
        query: { id: item.id },
      });
    },
    viewLead(item) {
      console.log(item);
      this.$store.commit("setViewingProposal", item);
      this.$router.push({
        name: "crm-view-proposal",
        params: { id: item.id },
      });
    },
    dailyUpdate(item) {
      this.data = { ...item };
      this.dialog = true;
    },
    viewInvoice(item) {
      this.$router.push({
        name: "view-proposal-invoice",
        params: { id: item.id },
      });
    },
    exportToPDF() {
      let serialNumber = 1;
      const columns = [ "#SL", "Code", "Company Name", "Company Email", "Company Phone", "Total", "Status" ];
      const rows = this.getSchema.map((item) => [ serialNumber++, item.code, item.company_name, item.company_email, item.company_phone, item.grand_total, item.status == 1 ? "Active" : "Inactive" ]);
      this.$exportTableToPDF( columns, rows, "Lead Proposal", "proposal_list_" + this.$fileDate() );
    },
    exportToExcel() {
      var data = [
        [ "#SL", "Code", "Company Name", "Company Email", "Company Phone", "Total", "Status" ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, item.code, item.company_name, item.company_email, item.company_phone, item.grand_total, item.status == 1 ? "Active" : "Inactive" ]);
      });
      this.$exportTableToExcel(data, "proposal_list_" + this.$fileDate());
    },
    exportToCSV() {
      var data = [
        [ "#SL", "Code", "Company Name", "Company Email", "Company Phone", "Total", "Status" ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, item.code, item.company_name, item.company_email, item.company_phone, item.grand_total, item.status == 1 ? "Active" : "Inactive" ]);
      });

      this.$exportTableToCSV(data, "proposal_list_" + this.$fileDate());
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.searchButton.$el.click();
    });   
  },
};
</script>
